import CloseIcon from '@mui/icons-material/Close'
import IconButton, { IconButtonProps } from '@mui/material/IconButton'
import useTranslate from '@/hooks/use-translate'

export type DialogCloseButtonProps = Omit<IconButtonProps, 'children'> & {
  onClose: () => void
}

/**
 * Bouton de fermeture standard pour les modales MUI Dialog.
 * À placer après DialogTitle ; complète onClose (backdrop + Échap).
 */
const DialogCloseButton = ({
  onClose,
  sx,
  ...props
}: DialogCloseButtonProps) => {
  const { t: tCommon } = useTranslate('common')

  return (
    <IconButton
      aria-label={tCommon('close')}
      onClick={onClose}
      sx={{
        position: 'absolute',
        right: 8,
        top: 8,
        color: (theme) => theme.palette.grey[500],
        ...sx,
      }}
      {...props}
    >
      <CloseIcon />
    </IconButton>
  )
}

export default DialogCloseButton
